import { render, staticRenderFns } from "./TheRegistration.vue?vue&type=template&id=7e39bb54"
import script from "./TheRegistration.vue?vue&type=script&lang=js"
export * from "./TheRegistration.vue?vue&type=script&lang=js"
import style0 from "./TheRegistration.vue?vue&type=style&index=0&id=7e39bb54&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports